import React from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helpersNumbers from "../../../../helpers/numbers";
import Advertises from "./ListAdvertise";
import { Link } from "react-router-dom";

export default function AllBanner() {
  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }
    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const btnAddAdvertiseBannerClick = () => {
    document.querySelector("#select-campaign").classList.remove("d-none");
    document
      .querySelector("#select-campaign select")
      .classList.remove("d-none");
  };

  const selectCampaignUser = (e) => {
    if (!e.target.value) {
      return;
    }
    document
      .querySelector("#btn-add-advertise-banner")
      .classList.remove("d-none");
  };

  const generateButtonAddAdvertise = () => {
    return (
      <div className="d-flex flex-column flex-lg-row pt-3">
        <div
          onClick={btnAddAdvertiseBannerClick}
          className="btn btn-success ml-2"
          to="/advertise/banner/add"
        >
          <span className="pl-2">
            <i className="fa fa-plus"></i>
          </span>
          <span>
            <span>اضافه کردن تبلیغ جدید به کمپین</span>
          </span>
        </div>
        <div
          className="ml-2 d-inline d-none py-2 py-lg-0 "
          id="select-campaign"
        >
          <select
            className="form-control d-none"
            onChange={(e) => {
              selectCampaignUser(e);
            }}
          >
            <option value="0">کمپین خود را انتخاب کنید</option>
            <option value="1">کمپین بنری روز مرد ۱۴۰۰</option>
          </select>
        </div>
        <div className="d-none" id="btn-add-advertise-banner">
          <Link to="/advertise/banner/add/4" className="btn btn-success">
            اضافه کردن
          </Link>
        </div>
      </div>
    );
  };

  const generateAllAdvertiseBannerUsers = () => {
    return (
      <>
        {generateButtonAddAdvertise()}
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تبلیغ</td>
                <td>شماره کمپین</td>
                <td>نام کمپین</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ بروزرسانی</td>
                <td>آدرس فرود</td>
                <td>وضعیت</td>
                <td>بررسی</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {Advertises.map((advertiseBannerUser, index) => {
                let classNameStateAdvertise = advertiseBannerUser.active
                  ? "success"
                  : "danger";
                let textStateAdvertise = advertiseBannerUser.active
                  ? "فعال"
                  : "غیر فعال";
                const [classNameConfirmAdvertise, textConfirmAdvertise] =
                  generateConfirmTag(advertiseBannerUser.confirm);

                return (
                  <tr key={index}>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(advertiseBannerUser.id)}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.campaign_id
                      )}
                    </td>

                    <td>{advertiseBannerUser.campaign_name}</td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.created_at
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.updated_at
                      )}
                    </td>
                    <td className=" text-center">
                      <a
                        className="btn btn-primary text-center"
                        target="_blank"
                        href={advertiseBannerUser.link}
                      >
                        <i className="fa fa-globe"></i>
                      </a>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameStateAdvertise} `}
                        >
                          {textStateAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameConfirmAdvertise}`}
                        >
                          {textConfirmAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/advertise/banner/edit/${advertiseBannerUser.id} `}
                            className="btn btn-success"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="all-advertise" activeItem="add-advertise-banner" />

      <div className="content-wrapper">
        <TitleBar title="تبلیغات بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning w-100 ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      هر تبلیغ فقط یک کمپین میتواند داشته باشد و هر کمپین فقط یک
                      تبلیغ میتواند داشته باشد.
                    </p>
                  </li>
                </ul>
              </div>
              {generateAllAdvertiseBannerUsers()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
